import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useImperativeHandle, forwardRef } from "react";
import { getClassNameFactory, getRehydratableName, Grid } from "@dcl/ui";
import { propsToDataAttributes } from "@tr-digital/react-rehydrate";
import Dropdown from "../../modules/Dropdown";
export var CascadingDropdown = /*#__PURE__*/forwardRef(function (props, ref) {
  var getClassName = getClassNameFactory(CascadingDropdown.displayName);
  var dependentDropdowns = props.dependentDropdowns,
      columns = props.columns;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedValues = _useState2[0],
      setSelectedValues = _useState2[1];

  var handleChange = function handleChange(dropdownName, value) {
    setSelectedValues(function (prevSelectedValues) {
      return _objectSpread(_objectSpread({}, prevSelectedValues), {}, _defineProperty({}, dropdownName, value));
    });
  };

  var getGridClass = function getGridClass(variant) {
    return "even-".concat(Math.min(Math.max(variant, 2), 6));
  };

  var isDropdownEnabled = function isDropdownEnabled(dropdown) {
    return dropdown.dependencies.length === 0 || dropdown.dependencies.every(function (dep) {
      return selectedValues[dep] && selectedValues[dep] !== "";
    });
  };

  var getTransformedDropdownOptions = function getTransformedDropdownOptions(optionsList) {
    return optionsList.map(function (option) {
      return {
        label: option,
        value: option
      };
    });
  };

  var getDropdownOptions = function getDropdownOptions(dropdown) {
    if (dropdown.dependencies.length > 0) {
      var dependentParent = dropdown.dependencies[0];
      var optionsList = dropdown.options[selectedValues[dependentParent]] || [];
      return getTransformedDropdownOptions(optionsList);
    }

    return getTransformedDropdownOptions(dropdown.options);
  };

  var filterFn = function filterFn(items, value) {
    if (typeof value !== "string") {
      return [];
    }

    var label = value.toLowerCase();
    return items.filter(function (item) {
      return item.label.toLowerCase().includes(label);
    });
  };

  var getSelectedValues = function getSelectedValues() {
    return selectedValues;
  };

  useImperativeHandle(ref, function () {
    return {
      getSelectedValues: getSelectedValues
    };
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: getClassName(),
    "data-rehydratable": getRehydratableName(CascadingDropdown.displayName)
  }, propsToDataAttributes(props)), /*#__PURE__*/React.createElement(Grid, {
    variant: getGridClass(columns)
  }, dependentDropdowns.map(function (dropdown) {
    return /*#__PURE__*/React.createElement(Grid.Item, {
      key: dropdown.name
    }, /*#__PURE__*/React.createElement("div", {
      key: dropdown.name
    }, /*#__PURE__*/React.createElement("label", {
      className: isDropdownEnabled(dropdown) ? "" : getClassName({
        descendantName: "disabledLabel"
      })
    }, dropdown.name, ":", " "), /*#__PURE__*/React.createElement(Dropdown, {
      typeaheadMode: true,
      filterFunction: filterFn,
      maxVisibleItems: 5,
      block: true,
      items: getDropdownOptions(dropdown),
      onValueChanged: function onValueChanged(value) {
        return handleChange(dropdown.name, value);
      },
      placeholder: "",
      removeAutoFocus: true,
      className: isDropdownEnabled(dropdown) ? "" : getClassName({
        descendantName: "disabled"
      })
    })));
  })));
});
CascadingDropdown.displayName = "CascadingDropdown";